import React from 'react';
import { useTranslation } from 'react-i18next';
import Landmark from 'components/Landmark';
import Text from 'components/Text';
import CenterContent from 'components/CenterContent';
import Stack from 'components/Stack';
function ErrorContent(_ref) {
  var errorMessage = _ref.errorMessage;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(CenterContent, {
    height: "90vh",
    contentWidth: 440
  }, /*#__PURE__*/React.createElement(Landmark, {
    icon: "logout"
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    as: "p"
  }, t('error_whoops_there_has_been_an_error')), errorMessage && /*#__PURE__*/React.createElement(Text, null, t(errorMessage)))));
}
export default ErrorContent;